import Tag from '../../../../components/Display/Tag';
import { getConstant } from '../../../../utils/constants';
import { getImage } from '../../../../utils/imageHelper';
import { cleanHtml } from '../../../../utils/stringHelper';
import styles from "../../cards.module.scss"

function ProgramListItem({ program, handleClickProgram, layout }) {
  return (
    <div
      className={`${styles.projectCard} ${layout === "grid" ? styles.projectCardGridLarge : ''}`}
      onClick={handleClickProgram}>
      <img
        className={styles.projectImage}

        src={program.main_image ? program.main_image.file : getImage('img-ph.png')}
        alt={program.main_image ? program.main_image.label : 'Non renseignée'}
      />
      <img
        className={styles.projectImage}
        src={program.secondary_image ? program.secondary_image.file : getImage('img-ph.png')}
        alt={program.secondary_image ? program.secondary_image.label : 'Non renseignée'}
      />
      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>{program.title}</p>
          <div
            dangerouslySetInnerHTML={{ __html: cleanHtml(program.description) }}
            className={styles.subtitle}
          />
        </div>
        <div className={styles.tagList}>

          <Tag tag={getConstant('melismes.common.statusTypes', program.status)} />
        </div>

      </div>
    </div>
  );
}

export default ProgramListItem;
